import { EnabledSubjectsPayload } from '../interfaces/enabledSubjects.interfaces';

export const enableSubjectsValues: EnabledSubjectsPayload = {
  period_id: 0,
  campus_id: 0,
  workday: '',
  hourhands: [],
};
